import { GraphUtils } from '@helpers/graph.helper';
import { Sensor, dataChart } from './sensor';
import { Router } from '@angular/router';

export class TensiometerSensor extends Sensor {
  public pressureChart: any;

  private pressSensor: any[];

  constructor(router: Router, url: string, alerstActive: boolean) {
    super(router, url, alerstActive);
    this.pressureChart = null;

    this.pressSensor = [[], [], []];
  }

  public hasPressSensor(pos: number): boolean {
    return this.pressSensor[pos - 1].length > 0;
  }

  public getPressSensor(pos: number): any {
    const realPos: number = this.pressSensor[pos - 1].length - 1;
    return this.pressSensor[pos - 1][realPos][1] ?? null;
  }

  public prepareData(): void {
    for (const element of this.data) {
      const date = new Date(element.date);
      this.pressSensor[element.position].push([
        GraphUtils.getDateUtc(date),
        element.pressure,
      ]);
    }
  }

  public setCharts(): void {
    this.pressureChart = this.getConfigChar(
      'tensiometer',
      this.getChartSeries('Pres', this.pressSensor),
      this.getRanges('2_pressure'),
      this.getLimits('2_pressure')
    );
  }

  public static getVariables(): any[] {
    return [
      { title: 'Tensión matricial', value: '2_pressure' }
    ];
  }
}